// src/components/LastMinuteDeals.js
import React from 'react';

// Import images (make sure these images are in the correct folder inside `src` or public directory)
import destination11 from '../images/service/a1.jpg';
import destination10 from '../images/service/a2.jpg';
import destination13 from '../images/service/a3.jpg';

const LastMinuteDeals = () => {
  const deals = [
    {
      id: 1,
      location: 'Morachi Chincholi is known for its large population of peacocks...',
      title: 'Peacock Watching',
      price: 180,
      days: '6 Days Tours',
      rating: 16,
      image: destination11,
    },
    {
      id: 2,
      location: 'Capture stunning photographs of peacocks against..',
      title: 'Photography',
      price: 140,
      days: '3 Days Tours',
      rating: 12,
      image: destination10,
    },
    {
      id: 3,
      location: 'Some places in Morachi Chincholi offer the opportunity to feed...',
      title: 'Peacock Feeding',
      price: 140,
      days: '3 Days Tours',
      rating: 12,
      image: destination13,
    },
  ];

  return (
    <section className="trending pb-9">
      <div className="container">
        <div className=" mb-6 w-75 mx-auto text-center">
          <h4 className="mb-1 theme1">Our Top Activities</h4>
          <h2 className="mb-1">
            Find Weekend Activities with <span className="theme">Anand Krushi Paryatan Kendra</span>
          </h2>
          <p>
            Whether you're looking for outdoor adventures, creative workshops, or fun family outings, we have something for everyone.
          </p>
        </div>

        <div className="trend-box">
          <div className="row">
            {deals.map((deal) => (
              <div className="col-lg-4 col-md-6 mb-4" key={deal.id}>
                <div className="trend-item1 rounded box-shadow bg-white">
                  <div className="trend-image position-relative">
                    <img src={deal.image} alt={deal.title} className="img-fluid" />
                    <div className="trend-content1 p-4">
                      <h5 className="theme1 mb-1">
                        <i className="flaticon-location-pin"></i> {deal.location}
                      </h5>
                      <h3 className="mb-1 white">
                        <a href="/tour-grid" className="white">{deal.title}</a>
                      </h3>
                     
                     
                    </div>
                    <div className="overlay"></div>
                  </div>
                </div>
              </div>
            ))}
           
          </div>
        </div>
      </div>
    </section>
  );
};

export default LastMinuteDeals;
